import type { SubmitRuleCategory } from './submitRuleMockData';
import type { PublishScope } from './submitRulePage.types';

export const countPendingRules = (categories: SubmitRuleCategory[]): number =>
  categories.reduce((total, category) => total + category.rules.length, 0);

export const countPendingBlocks = (categories: SubmitRuleCategory[]): number =>
  categories.filter((category) => category.rules.length > 0).length;

export const getPublishModalTitle = (scope: PublishScope): string => {
  if (scope.type === 'block') {
    return `Publier le bloc — ${scope.title}`;
  }

  return `Publier toutes les règles (${scope.ruleCount})`;
};

export const getPublishModalDescription = (scope: PublishScope): string => {
  if (scope.type === 'block') {
    return `${scope.ruleCount} règle(s) du bloc « ${scope.title} » seront envoyées en production.`;
  }

  const blocksLabel = scope.blockTitles.join(', ');

  return `${scope.ruleCount} règle(s) réparties dans ${scope.blockCount} bloc(s) (${blocksLabel}) seront publiées.`;
};
